'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import css from './style.module.scss';
interface Props {
  filled: number;
  total: number;
  label: string;
  className?: string;
}
const LeadMagnetProgress: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    filled,
    total,
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.track, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filled || $[3] !== total) {
    let t3;
    if ($[5] !== filled) {
      t3 = (_, index) => <span key={index} className={clsx(css.segment, index < filled && css.segmentFilled)} />;
      $[5] = filled;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = Array.from({
      length: total
    }, t3);
    $[2] = filled;
    $[3] = total;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== filled || $[8] !== label || $[9] !== t1 || $[10] !== t2 || $[11] !== total) {
    t3 = <div className={t1} role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={filled} aria-valuetext={label}>{t2}</div>;
    $[7] = filled;
    $[8] = label;
    $[9] = t1;
    $[10] = t2;
    $[11] = total;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default LeadMagnetProgress;